import React from 'react';
import { TextField, Typography } from '@mui/material';
import SubMatFolderGlassBom from './SubMatFolderGlassBom';
import SubMatFolderMaterialSlotFields from './SubMatFolderMaterialSlotFields';
import SubMatFolderClassification from './SubMatFolderClassification';

/**
 * 성적서 분석에 필요한 폴더 속성 칸만 보여 준다.
 * 폴더에 이미 있는 값은 고칠 수 없다.
 */
const SubMatComparisonLeadForm = ({
  hasStandard = false,
  cert,
  certMessage = '',
  plan,
  busy = false,
  glass,
  onGlass,
  glassLocked = false,
  slot,
  slotValues,
  onSlot,
  slotLocked = false,
  plainThickness = '',
  onPlainThickness,
  plainLocked = false,
  gradeLocked = false,
  gradeText = '',
  gradeSeed = [],
  onGradeParts,
  gradeKey = 'grade',
}) => {
  if (!hasStandard || !plan) return null;
  if (!cert) {
    if (!certMessage) return null;
    return (
      <Typography variant="body2" color="text.secondary">
        {certMessage}
      </Typography>
    );
  }

  const thicknessSlot = plan.showSlot && slot
    ? { ...slot, details: plan.thicknessDetails }
    : null;

  return (
    <>
      {plan.showGlass && (
        <SubMatFolderGlassBom
          certificationId={cert.id}
          value={glass}
          onChange={onGlass}
          readOnly={glassLocked || busy}
          showTitle={false}
          inline
        />
      )}
      {thicknessSlot && (
        <SubMatFolderMaterialSlotFields
          slot={thicknessSlot}
          value={slotValues}
          onChange={onSlot}
          omitProduct
          readOnly={slotLocked || busy}
          inline
        />
      )}
      {plan.showPlain && (
        <TextField
          size="small"
          label="두께 (mm)"
          type="number"
          value={plainThickness}
          onChange={(e) => onPlainThickness?.(e.target.value)}
          disabled={plainLocked || busy}
          inputProps={{ step: 'any' }}
          sx={{
            width: 160,
            '& .MuiInputLabel-root': { fontSize: '0.9rem' },
            '& .MuiOutlinedInput-root': { height: 40 },
            '& .MuiInputBase-input': { fontSize: '0.9rem', py: 0 },
          }}
        />
      )}
      {plan.showGrade && gradeLocked && (
        <TextField
          size="small"
          label="등급"
          value={gradeText}
          InputProps={{ readOnly: true }}
          disabled
          sx={{
            width: 280,
            maxWidth: '100%',
            '& .MuiInputLabel-root': { fontSize: '0.9rem' },
            '& .MuiOutlinedInput-root': { height: 40 },
            '& .MuiInputBase-input': { fontSize: '0.9rem', py: 0 },
          }}
        />
      )}
      {plan.showGrade && !gradeLocked && (
        <SubMatFolderClassification
          key={gradeKey}
          certId={cert.id}
          classifications={cert.classifications}
          isProcess={cert.division === 'PROCESS'}
          certCode={cert.code}
          glassItems={glass?.selectedGcomponentItems}
          savedParts={gradeSeed}
          onChange={onGradeParts}
          inline
        />
      )}
    </>
  );
};

export default SubMatComparisonLeadForm;
